import { configureStore } from '@reduxjs/toolkit'
import { popupSlice } from 'components/Popup/popupSlice';
import {userSlice} from '../components/user/userSlice';


const store =  configureStore({
    reducer: {
        user: userSlice.reducer,
        popup: popupSlice.reducer,
    },
});

export type RootState = ReturnType<typeof store.getState>
export default store
export type AppDispatch = typeof store.dispatch